import { AnalyticsFeedbackDialog } from "@components/analytics/in-house/feedback/analytics-feedback-dialog";
import { IconButton, Tooltip } from "@flat-ui";
import { useState } from "react";
import { FeedbackIcon } from "@flat-ui";

/**
 * Action button that opens the in-house premium analytics feedback survey on
 * demand. Rendered in the analytics tab bar's action area.
 */
export function AnalyticsProvideFeedbackButton(): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Tooltip title="Provide feedback">
        <IconButton onClick={() => setIsDialogOpen(true)} size="s">
          <FeedbackIcon />
        </IconButton>
      </Tooltip>
      {isDialogOpen && (
        <AnalyticsFeedbackDialog onClose={() => setIsDialogOpen(false)} />
      )}
    </>
  );
}
